import { render, staticRenderFns } from "./menu-around.vue?vue&type=template&id=329fa830&"
import script from "./menu-around.vue?vue&type=script&lang=js&"
export * from "./menu-around.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports